import gql from 'graphql-tag'

export default gql`mutation ycmdMessageResend($message_id: ID) {
	ycmdMessageResend(message_id: $message_id) {
		status
	}
}`
